<form [formGroup]="minorCodeForm" (ngSubmit)="onFormSubmit()" autocomplete="off">
  <div class="row">
    <div class="col-6 mb-3">
      <generic-dropdown
        [items]="jobTypeList()"
        [label]="'Job Type'"
        [allowSearch]="true"
        [clearable]="true"
        [required]="true"
        [placeholder]="'Select Job Type'"
        [errormessage]="'Job Type is required'"
        formControlName="jobTypeId"
        [disabled]="!!idToEdit()"
      >
      </generic-dropdown>
    </div>
    <div class="col-6 mb-3">
      <input-field
        [label]="'Code'"
        [type]="'text'"
        [placeholder]="'Enter minor code'"
        formControlName="code"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Minor Code is required'"
      ></input-field>
    </div>
    <div class="col-12 mb-3">
      <input-field
        [label]="'Description'"
        [type]="'text'"
        [placeholder]="'Enter code description'"
        formControlName="description"
        [requiredLabel]="true"
        [required]="true"
        [errormessage]="'Description is required'"
      ></input-field>
    </div>
    <div class="col-12 mb-3">
      <input-field
        [label]="'Abbreviation'"
        [type]="'text'"
        [placeholder]="'Enter code abbreviation'"
        formControlName="abbreviation"
      ></input-field>
    </div>

    <div class="col-6 mb-3">
      <generic-dropdown
        [items]="minorCodesStatusList()"
        [label]="'Status'"
        [allowSearch]="true"
        [clearable]="true"
        formControlName="type"
        [placeholder]="'Select status'"
        [required]="true"
        [errormessage]="'Status is required'"
      >
      </generic-dropdown>
    </div>
    <div class="col-6 mb-3">
      <generic-dropdown
        [items]="minorCodesCategoryList()"
        [label]="'Category'"
        [allowSearch]="true"
        [clearable]="true"
        formControlName="category"
        [placeholder]="'Select category'"
        [required]="true"
        [errormessage]="'Category is required'"
      >
      </generic-dropdown>
    </div>
    <div class="col-12 mb-3">
      <generic-dropdown
        [items]="uofmList()"
        [label]="'Unit of Measurement'"
        [allowSearch]="true"
        [clearable]="true"
        formControlName="unitOfMeasureId"
        [placeholder]="'Select unit of measurement'"
      >
      </generic-dropdown>
    </div>
    <div class="row mt-3">
      <div class="col-auto mb-3">
        <div class="d-flex gap-2 align-items-center">
          <label class="mb-0 fs-14">Quantity Required</label>
          <div class="d-flex align-items-center">
            <p-toggleswitch class="d-flex align-items-center" formControlName="quantityRequired" />
          </div>
        </div>
      </div>
      <div class="col-auto">
        <div class="d-flex gap-2 align-items-center">
          <label class="mb-0 fs-14">Unit Price Required</label>
          <div class="d-flex align-items-center">
            <p-toggleswitch class="d-flex align-items-center" formControlName="unitPriceRequired" />
          </div>
        </div>
      </div>
      <div class="col-auto">
        <div class="d-flex gap-2 align-items-center">
          <label class="mb-0 fs-14">Hour Required</label>
          <div class="d-flex align-items-center">
            <p-toggleswitch class="d-flex align-items-center" formControlName="hourRequired" />
          </div>
        </div>
      </div>
      <div class="col-auto">
        <div class="d-flex gap-2 align-items-center">
          <label class="mb-0 fs-14">Amount Required</label>
          <div class="d-flex align-items-center">
            <p-toggleswitch class="d-flex align-items-center" formControlName="amountRequired" />
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
